import React, { createContext, useState } from 'react';

type stateType = {
  isVideoModalOpened: boolean;
  setVideoModalStatus: Function;
  videoModalData: {
    url?: string;
    verseId?: string;
    duration?: number;
    title?: string;
    expertName?: string;
    bumperUrl?: string | null;
  };
  setVideoModalData: Function;
};

const STATE: stateType = {
  isVideoModalOpened: false,
  setVideoModalStatus: () => {},
  videoModalData: { url: '' },
  setVideoModalData: () => {},
};

export const ModalsContext = createContext(STATE);

export const ModalsController = ({ children }) => {
  const [isVideoModalOpened, setVideoModalStatus] = useState(false);
  const [videoModalData, setVideoModalData] = useState({ url: '' });

  return (
    <ModalsContext.Provider
      value={{
        isVideoModalOpened,
        setVideoModalStatus,
        videoModalData,
        setVideoModalData,
      }}
    >
      {children}
    </ModalsContext.Provider>
  );
};
